import * as React from "react";

const FiltrationIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="60"
        height="60"
        fill="none"
        viewBox="0 0 60 60"
    >
        <rect
            width="59"
            height="59"
            x="0.5"
            y="0.5"
            stroke="#686A71"
            rx="7.5"
        ></rect>
        <path
            stroke="#1E212B"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M31 22H21M29 37h-8M39 37h-4M39 29.5H29M39 22h-2M23 29.5h-2M32.5 20c.466 0 .699 0 .883.076a1 1 0 0 1 .54.541c.077.184.077.417.077.883v1c0 .466 0 .699-.076.883a1 1 0 0 1-.541.54c-.184.077-.417.077-.883.077s-.699 0-.883-.076a1 1 0 0 1-.54-.541C31 23.199 31 22.966 31 22.5v-1c0-.466 0-.699.076-.883a1 1 0 0 1 .541-.54c.184-.077.417-.077.883-.077M30.5 35c.466 0 .699 0 .883.076a1 1 0 0 1 .54.541c.077.184.077.417.077.883v1c0 .466 0 .699-.076.883a1 1 0 0 1-.541.54c-.184.077-.417.077-.883.077s-.699 0-.883-.076a1 1 0 0 1-.54-.541C29 38.199 29 37.966 29 37.5v-1c0-.466 0-.699.076-.883a1 1 0 0 1 .541-.54c.184-.077.417-.077.883-.077M27.5 27.5c.466 0 .699 0 .883.076a1 1 0 0 1 .54.541c.077.184.077.417.077.883v1c0 .466 0 .699-.076.883a1 1 0 0 1-.541.54c-.184.077-.417.077-.883.077s-.699 0-.883-.076a1 1 0 0 1-.54-.541C26 30.699 26 30.466 26 30v-1c0-.466 0-.699.076-.883a1 1 0 0 1 .541-.54c.184-.077.417-.077.883-.077"
        ></path>
    </svg>
);

export default FiltrationIcon;
